import { Download } from "@mui/icons-material";
import { GridActionsCellItem } from "@mui/x-data-grid";
import { isoToDateString, isoToDateTimeString, monthEnding } from "utils/date";
import { makeTable } from "views/Manager/LicencePage/LicenceGenerator";

const openNewTab = (body) => {  
  let items="";
  body.forEach(item => {
    items += `<tr><td>${item.factoryNumber}</td><td>${item.license}</td></tr>`;
  });

  
  const htmlContent = makeTable(items);
  
  const blob = new Blob([htmlContent], { type: "text/html;charset=utf-8" });
  const url = URL.createObjectURL(blob);

  window.open(url, "_blank");
};
    
export default [

  { field: 'createdAt', headerAlign: 'center', headerName: 'Созданы', width: 90, 
    valueGetter: (value) => isoToDateString(value) },

  { field: 'duration', width: 100, headerAlign: 'center', headerName: 'Длительность', align: 'center', 
    valueGetter: (value) => `${value} ${monthEnding(value)}` }, 
    
  { field: 'endActivationAt', headerAlign: 'center', headerName: 'Активация до', width: 100, align: 'center',
    valueGetter: (value) => isoToDateString(value) },

  { field: 'range', headerAlign: 'center', headerName: 'Диапазон ЗН', width: 140, align: 'center'},

  { field: 'quantity', headerAlign: 'center', headerName: 'Количество', width: 90, align: 'center'},

  { field: 'subjectType', headerAlign: 'center', headerName: 'Тип лицензии', width: 100, align: 'center',
    valueGetter: (value) => value==='apps' ? 'Приложение' : 'Профиль' },

  { field: 'subject', headerAlign: 'center', headerName: 'Предмет лицензирования', flex: 1, align: 'center'},

  { field: 'actions', type: 'actions', width: 50, getActions: ({row}) => [
        <GridActionsCellItem icon={<Download />} label="Скачать" onClick={() => openNewTab(row.items)} />
      ]}

];    